export const addTicketActionsStyle = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    gap: '24px',
    bottom: '24px',
    maxWidth: '1170px',
    width: '100%',
    height: '80px',
    padding: '0 100px',
    background: 'var(--neutral-100)',
    left: 'calc(50% - 585px)',
    borderRadius: '0 0 8px 8px',

    '@media (max-width: 1199.98px)': {
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '0 24px',
      bottom: '0px',
      maxWidth: '1200px',
    },

    '@media (max-width: 639.98px)': {
      display: 'none',
    },

    // '@media (min-width: 1200.00px)': {
    //   left: 'calc(50% - 290px)',
    //   right: '0px',
    //   padding: '0 24px',
    //   borderRadius: '8px',
    //   maxWidth: '870px',
    // },
  },

  wrapperFromPage: {
    '@media (min-width: 1200.00px)': {
      left: 'calc(50% - 290px)',
      right: '0px',
      padding: '0 24px',
      borderRadius: '8px',
      maxWidth: '870px',
    },
  },

  button: {
    height: '44px',
    fontWeight: 700,

    '&.MuiButton-outlinePrimary': {
      backgroundColor: 'var(--neutral-100)',

      '&:hover': {
        backgroundColor: 'var(--primary-100)',
        color: 'var(--primary-500)',
      },
    },
  },
};
